
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'list',
  setup() {
    return {}
  }
})
